/* 🤖 this file was generated by svg-to-ts */
export const iconCbeth: {
  name: 'cbeth';
  data: string;
} = {
  name: 'cbeth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M15.89.12C7.11.12 0 7.23 0 16.01S7.11 31.9 15.89 31.9s15.89-7.11 15.89-15.89S24.67.12 15.89.12m0 30.9c-8.29 0-15-6.72-15-15s6.72-15 15-15 15 6.72 15 15-6.72 15-15 15"/><path fill="currentColor" d="M15.89 2.51c-7.46 0-13.5 6.05-13.5 13.5s6.05 13.5 13.5 13.5 13.5-6.05 13.5-13.5-6.05-13.5-13.5-13.5m0 24.4-6.71-9.6 6.71 4.02 6.72-3.95zm0-6.89-6.7-4.01 6.7-11.32 6.72 11.34-6.72 4.01z"/></svg>`,
};
